import React from 'react';
import { Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap-5';

import { formatDate } from 'helpers/formatters/date_time_formats';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faFilePdf } from '@fortawesome/pro-solid-svg-icons';
import { isEmpty } from 'lodash';

type Props = {
  document: {
    date?: string;
    title?: string;
    url?: string;
    id?: number;
  }
}

export default function DocumentListItem({ document }: Props) {
  const unavailable = isEmpty(document.url);

  const linkColumn = () => {
    if (unavailable) return null;

    return (
      <Col className="fw-bold text-primary" md={3}>
        <a href={document.url} rel="noopener noreferrer" target="_blank">
          View
          <FontAwesomeIcon className="ms-2" icon={faArrowRight} size="1x" />
        </a>
      </Col>
    );
  };

  const body = (
    <Row className="mx-2 p-3 bg-light rounded border align-items-center">
      <Col md={2}>
        <FontAwesomeIcon className={unavailable ? 'text-muted' : 'icon-gradient'} icon={faFilePdf} size="2x" />
      </Col>
      <Col md={unavailable ? 10 : 7}>
        <div className="text-truncate fw-bold">{document.title}</div>
        <div className="small text-muted">{formatDate(document.date)}</div>
      </Col>
      {linkColumn()}
    </Row>
  );

  if (!unavailable) return (
    <Col md={6}>
      {body}
    </Col>
  );

  const unavailableTooltip = (
    <Tooltip id={`unavailable-document-${document.id}`}>
      Document not available
    </Tooltip>
  );

  return (
    <Col md={6}>
      <OverlayTrigger overlay={unavailableTooltip}>
        {body}
      </OverlayTrigger>
    </Col>
  );
}
